import React, { useContext, useEffect, useState } from 'react';
import ChangePasswordDialog from 'components/Tvendo/Common/ChangePasswordDialog';
import ScrollToTop from 'components/Tvendo/Common/ScrollToTop';
import { RouteAction } from 'contexts/routeReducer';
import { UserContext } from 'contexts/userContext';
import { useRoutes } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import Loading from 'layouts/Loading';
import { useApp } from 'hooks/useApp';
import './assets/scss/loading.scss';
import routes from 'tvendo-routes';

const App = () => {
  const { isInitialized } = useAuth();
  // const mounted = useMounted();
  const { routeDispacher } = useApp();
  const [routeLoaded, setRouteLoaded] = useState(false);
  const { user } = useContext(UserContext);

  useEffect(() => {
    const initialize = async () => {
      if (isInitialized) {
        routeDispacher({ type: RouteAction.register, payload: routes });
        setRouteLoaded(true);
      }
    };
    initialize();
  }, [isInitialized]);

  const content = useRoutes(routes);
  if (!isInitialized || !routeLoaded) {
    return <Loading />;
  }
  return (
    <>
      {user !== null && user.reset_password === true && <ChangePasswordDialog />}
      <ScrollToTop />
      {isInitialized && content}
    </>
  );
};

export default App;
